<template>
  <div class="blogroll">
    <div class="linktitle">
      <h3>友情链接：</h3>
      <ul>
        <li :class="isSelect == 'separtments' && 'select'" @click="changeLink('separtments')">部门网站</li>
        <li :class="isSelect == 'members'&&'select'" @click="changeLink('members')">会员单位</li>
        <li :class="isSelect == 'relatives'&&'select'" @click="changeLink('relatives')">相关网站</li>
      </ul>
    </div>
    <div class="linkurl">
      <ul>
        <li v-for="(link) in links.slice(0,5)" :key="link.id"><a :href="link.url" target="_blank">{{link.name}}</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getLiveBlogroll } from '@/request/get'
export default {
  name: "LiveBlogroll",
  components: {
  },
  data() {
    return {
      links:[],
      members:[],
      separtments:[],
      relatives: [],
      isSelect:'separtments'
    }
  },
  mounted() {
    this.getLiveBlogroll();
  },
  methods: {
    changeLink(link) {
      this.isSelect = link;
      this.links = this[link];
    },
    async getLiveBlogroll() {
      let result = await getLiveBlogroll();
      result = result.data;
      console.log(result);
      if (Array.isArray(result)) {
        result.forEach((item) => {
          if (item.type == "会员单位" || item.type == "友情链接") {
            this.members.push(item);
          } else if (item.type == "部门网站") {
            this.separtments.push(item);
          } else if (item.type == "相关网站") {
            this.relatives.push(item);
          }
        });
        this.links = this.separtments;
      }
    }
  }
};
</script>
<style scoped>
.blogroll{
  position: relative;
  margin-top: 52px;
  width: 1300px;
  height: 140px;
  border: 1px solid #ECECEC;
}
.blogroll>.linktitle{
  width: 1300px;
  height: 57px;
  border-bottom: 1px solid rgba(236, 236, 236,.8);
  background: url(/static/img/img/icon_yuqing.png) no-repeat 13px 17px;
  background-size: 24px 24px;
  display: flex;
  justify-content: start;
  align-items: center;
}
.blogroll>.linktitle>h3{
  width: 130px;
  height: 57px;
  padding-left: 46px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #2E8EEB;
  line-height: 57px;
}
.blogroll>.linktitle>ul{
  height: 57px;
  flex: 1;
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 57px;
}
.blogroll>.linktitle>ul>li{
  position: relative;
  width: 200px;
  text-align: center;
}
.blogroll>.linktitle>ul>li:nth-child(-n+2)::after{
  position: absolute;
  top:23px;
  right: 0;
  content: "";
  display:inline-block;
  width: 1px;
  height: 13px;
  background: #CCCCCC;
}
.blogroll>.linktitle>ul>li.select{
  color: #2E8EEB;
}
.blogroll>.linkurl>ul{
  width: 1251px;
  padding:0 34px 0 15px;
  height: 83px;
  display: flex;
  justify-content:space-between;
  align-items: center;
}
.blogroll>.linkurl>ul>li {
  position: relative;
  padding-left: 17px;
  height: 83px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 83px;
  -webkit-background-clip: text;
    word-break: break-all;
  -webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  /* width: 300px; */
  padding: 0 5px;
}
.blogroll>.linkurl>ul>li::before{
  position: absolute;
  top:38px;
  left: 0px;
  content: "";
  width: 5px;
  height: 5px;
  background: #CCCCCC;
  border-radius: 50%;
}

</style>
